/**
 * 设备检测 Mixin
 */
import { isMobile, isTablet, getDeviceType } from '@/utils/device'

export default {
  data() {
    return {
      ismobile: false,
      isTablet: false,
      deviceType: 'desktop'
    }
  },
  mounted() {
    this.detectDevice()
  },
  methods: {
    /**
     * 检测设备类型
     */
    detectDevice() {
      this.ismobile = isMobile()
      this.isTablet = isTablet()
      this.deviceType = getDeviceType()
    }
  }
}

